<span class="m-0">Nouveau message</span>
<button nzSize="small" nz-button nzType="text" class="ant-btn-icon-only" (click)="close()">
    <span nz-icon nzType="close"></span>
</button>